module.exports = __webpack_public_path__ + "img/opet-infographic-07.b5bc661c.jpg";